import React, { Component } from "react";
import io from "socket.io-client";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import authSvgwww from "../assests/foto.png";
import { signout, isAuth, getCokie } from "../helpers/auth";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";

import axios from "axios";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import TimeAgo from 'timeago-react'; // var TimeAgo = require('timeago-react');
import Markdownkatexnew from "../components/Markdown";
import * as timeago from 'timeago.js';
import "leaflet/dist/leaflet.css";


import es from 'timeago.js/lib/lang/es';
timeago.register('es', es);


const VenueLocationIcon = L.icon({
  iconUrl: require("../assests/venue_location_icon.svg"),
  iconRetinaUrl: require("../assests/venue_location_icon.svg"),
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [35, 35],
  className: "leaflet-venue-icon",
})
export default class Admin extends Component {
  state = {
    userr: [],
  };


  constructor() {
    super();
    this.ref = React.createRef();
    this.showNotification = this.showNotification.bind(this);
    this.state = {
      messages: [],
      users: [],
      mensaje: "",
      position: [52.52437, 13.41053],
      locations: [
        // { id: 1, name: "Location A", geometry: [-12.922146121983037, -74.25749614288173] },
        // { id: 2, name: "Location B", geometry: [-12.914026327499352, -74.295863226803] }
      ],
      zoom: 13,
      longitude: 0,
      latitude: 0,
      accuracy: 0
    };
  }

  componentWillUnmount() {
    this.socket.disconnect();
  }

  componentDidMount() {
    this.socket = io(`${process.env.REACT_APP_URL}`);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.setState({
          longitude: position.coords.longitude,
          latitude: position.coords.latitude,
          accuracy: position.coords.accuracy
        });
        if (isAuth()) {
          this.getUser();
        } else {
          const www = {
            user: 'user', email: 'www@www.email', name: 'name', id: 'id', foto: 'foto', ref: window.location.href, geometry: [position.coords.latitude, position.coords.longitude], accuracy: position.coords.accuracy
          };
          this.socket.emit("usssers", www)
        }

      },
      (error) => {
        console.error("Error Code = " + error.code + " - " + error.message);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );

    if (!("Notification" in window)) { alert("This browser does not support desktop notification"); } else { Notification.requestPermission(); }


    this.socket.on("mesages", (ww) => {
      //console.log(ww, "www");
      if (isAuth()._id === ww.user) { } else {
        toast.warn("Mensaje de " + ww.name);
      }
      this.setState({
        messages: [ww, ...this.state.messages],
      });
      //beep([1000, 500, 2000]);
    })

    this.socket.on("usersss", (ww) => {
      console.log(ww, "ww")
      this.setState({
        users: []
      })

      for (let i = 0; i < ww.length; i++) {
        const newMarker = {
          id: ww[i].email,
          name: ww[i].name,
          geometry: ww[i].geometry
        }
        console.log(newMarker)
        this.setState({
          users: [ww[i], ...this.state.users],
          locations: [newMarker, ...this.state.locations],
        })
      }
    })


    this.socket.on("load old msgs", (ww) => {
      console.log(ww, "load old msgs")
      for (let i = 0; i < ww.length; i++) {
        const www = { mensaje: ww[i].mensaje, email: ww[i].email, name: ww[i].name, create: ww[i].createdAt, foto: ww[i].foto };

        this.setState({
          messages: [www, ...this.state.messages],
        });
      }
      console.log(this.state.messages);
    });
  }

  sendMessage = () => {
    const user = isAuth()._id
    const name = `${this.state.userr.name}`
    const email = `${this.state.userr.email}`
    const mensaje = this.state.mensaje
    if (mensaje && name && email) {
      this.socket.emit("mesagess", { mensaje, user, name, email });
    }
    this.setState({ mensaje: "" });
  };

  getUser = async () => {
    const token = getCokie("token");
    await axios.get(
      `${process.env.REACT_APP_API_URL}/users/user/${isAuth()._id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ContentType: 'application/json; charset=UTF-8',
          Accept: `application/json`,
        },
      }
    ).then((res) => {
      this.setState({
        userr: res.data,
      })
      const www = { user: res.data._id, email: res.data.email, name: res.data.name.replace(/[^\x00-\x7F]/g, '&#209'), id: res.data._id, foto: res.data.foto, ref: window.location.href, geometry: [this.state.latitude, this.state.longitude], accuracy: this.state.accuracy };
      this.socket.emit("usssers", www)
    })
      .catch((err) => {
        if (err.response.status === 401) {
          signout(() => {
            window.location.href = "/login";
          });
        }
      });
  }


  wwWww = () => {
    console.log(this.state.users)
    console.log(this.state.locations)
    const www = { id: 1, name: "Location A", geometry: [-12.915284490709649, -74.27852406095573] }
    this.setState({
      locations: [www, ...this.state.locations],
    })
  }
  showNotification() {
    new Notification("Hey");
  }



  render() {
    const messagges = this.state.messages.map((message, i) => {
      return (
        <div key={i} className={`my-2 p-1 ${isAuth().email === message.email ? 'border-right border-warning' : 'border-left border-primary'}`} style={isAuth().email === message.email ? { fontSize: 14, float: "right", clear: "right" } : { fontSize: 14, float: "left", clear: "left" }}>
          <div className={`text-left ${isAuth().email === message.email ? 'text-info' : 'text-primary'}`} style={{ fontSize: 14 }}>
            {message.name + '-' + message.email}
          </div>
          <Markdownkatexnew>
            {message.mensaje}
          </Markdownkatexnew>
          <div className="text-secondary text-right" style={{ fontSize: 12 }}>
            <TimeAgo datetime={message.create} locale='es_ES' />
          </div>

          {/* <MessageList
            className="message-list"
            lockable={true}
            toBottomHeight={"100%"}
            dataSource={[
              {
                title: message.name + '-' + message.email,
                position: isAuth().email === message.email ? "right" : "left",
                type: "text",
                text: <Markdownkatexnew>{message.mensaje.replace(new RegExp('</p>', 'g'), '').replace(new RegExp('<p>', 'g'), '')}</Markdownkatexnew>,
                date: message.create ? new Date(message.create) : new Date(),
              },
            ]}
          /> */}
        </div>
      );
    });

    const usser = this.state.users.map((user, j) => {
      return (
        <div key={j} className="rounded border p-1 d-flex justify-content-between pb-0 rounded" style={{ marginBottom: ".2em" }}>
          <img className="wrapperestchat p-0" alt="www"
            src={
              `${process.env.REACT_APP_URL}/profile/` + user.foto
            }
            onError={(e) => {
              e.target.src = authSvgwww; e.target.style = "padding: 3px";
            }}
          />
          <div className="text-secondary text-right p-0" style={{ fontSize: 12 }}>
            {user.email} {isAuth().rol === '1' ? user.ip.substring(7) : ""} {isAuth().rol === '1' ? user.ref : ""}
            <TimeAgo datetime={user.time} locale='es_ES' />
            {/* <ChatList
                className="chat-list"
                dataSource={[
                  {
                    avatar: 'https://avatars.githubusercontent.com/u/80540635?v=4',
                    alt: "Reactjs",
                    title: user.email,
                    subtitle: user.name,
                    date: new Date(),
                    unread: 2,
                  },
                ]}
              /> */}
          </div>
        </div>
      );
    });

    const usserMarker = this.state.locations.map((loc, j) => {
      return (
        <Marker key={`${j}.${loc.id}`} position={loc.geometry} icon={VenueLocationIcon}>
          <Popup>{loc.name}</Popup>
        </Marker>
      );
    });


    return (
      <>
        {
          // isAuth().rol === '1' || window.location.href === `http://localhost:3000/tramites` ?
          // isAuth().rol === '1' || window.location.href === `${process.env.REACT_APP_pro}/tramites` ?
          <div className="container border my-3 rounded">
            <div className="row">
              <div className="col-md-4 rounded-left p-2"> {usser} </div>
              <div className="col-md-8 rounded-right p-2">
                {this.state.latitude} {this.state.longitude} {this.state.accuracy} {/* <textarea value={this.state.mensaje} ></textarea> */}
                <CKEditor className="rounded"
                  editor={ClassicEditor}
                  config={{ language: 'es', toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "|", "undo", "redo"], placeholder: 'Descripción', isReadOnly: 'true' }}
                  data={this.state.mensaje}
                  onChange={(event, editor) => { this.setState({ mensaje: editor.getData() }) }}
                // onReady={editor => { console.log('Editor is ready to use!', editor) }}
                />
                <div className="w-100">
                  <button className="btn btn-info w-100 rounded-0" onClick={this.sendMessage} > Enviar </button>
                  {/* <button className="btn btn-info w-100 rounded-0" onClick={this.wwWww} > wwwEnviar </button> */}
                </div>
                {messagges}
              </div>
            </div>
            {isAuth().rol === '1' ? <Map center={{ lat: this.state.latitude, lng: this.state.longitude }} zoom={this.state.zoom}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
              {usserMarker}
            </Map> : ''}

          </div>
          // : ""
        }
      </>
    );
  }
}
